function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M157.597,10.629c12.895-4.862,24.628-8.115,33.521-10.206C192.309,0.142,193.527,0,194.737,0 c4.788,0,9.255,2.171,12.253,5.956c2.982,3.765,4.061,8.611,2.959,13.297c-2.091,8.893-5.345,20.626-10.207,33.521L157.597,10.629z  M170.634,145.342c0.415,2.079-0.067,4.235-1.33,5.938l-41.574,56.058c-1.458,1.965-3.719,3.033-6.028,3.033 c-1.205,0-2.422-0.29-3.546-0.894c-3.278-1.762-4.77-5.661-3.502-9.161c0.097-0.269,8.211-22.987,6.313-38.654 c-0.748-6.171-2.434-11.409-4.173-15.482c-2.643,0.516-5.278,0.797-7.904,0.882l-4.593,15.157c-0.765,2.523-2.797,4.459-5.354,5.1 c-0.604,0.151-1.216,0.225-1.823,0.225c-1.965,0-3.88-0.773-5.304-2.197l-1.188-1.188c-3.573,7.208-9.464,16.41-18.41,23.066 c-14.64,10.892-43.534,11.739-52.044,11.739c-0.001,0,0,0-0.001,0c-0.911,0-1.411-0.011-1.411-0.011 c-4.018-0.087-7.26-3.325-7.343-7.343c-0.078-3.753-0.41-37.143,11.728-53.457c6.655-8.945,15.858-14.837,23.065-18.409 l-1.188-1.189c-1.863-1.864-2.612-4.57-1.972-7.126c0.642-2.557,2.577-4.59,5.101-5.354l15.145-4.589 c0.083-2.624,0.391-5.258,0.906-7.899c-4.078-1.744-9.321-3.433-15.494-4.181c-1.538-0.187-3.232-0.281-5.035-0.281 c-15.263,0-33.435,6.525-33.616,6.591c-3.501,1.271-7.401-0.222-9.163-3.501c-1.763-3.28-0.852-7.355,2.139-9.573L59.09,41.067 c1.703-1.263,3.861-1.746,5.938-1.331c0.767,0.153,3.983,0.92,13.211,4.347c4.526,1.681,9.319,4.011,13.248,6.08 c15.556-14.662,33.769-25.446,51.115-33.316l50.921,50.92c-7.87,17.346-18.654,35.56-33.315,51.115 c2.069,3.929,4.399,8.722,6.08,13.249C169.715,141.359,170.481,144.576,170.634,145.342z M79.277,152.809l-21.722-21.722 c-5.62,2.26-15.899,7.317-22.374,16.019c-6.07,8.158-8.125,25.454-8.639,36.716c13.455-0.587,29.241-3.067,36.722-8.632 C71.921,168.749,77.002,158.439,79.277,152.809z M154.127,97.829c5.554-5.554,8.612-12.938,8.612-20.793 c0-7.854-3.059-15.239-8.612-20.792c-5.555-5.554-12.938-8.613-20.793-8.613s-15.238,3.059-20.793,8.613 c-5.554,5.554-8.612,12.938-8.612,20.792c0,7.854,3.059,15.239,8.612,20.793c5.555,5.554,12.938,8.613,20.793,8.613 S148.573,103.383,154.127,97.829z M133.335,62.631c-3.848,0-7.465,1.499-10.186,4.219c-2.722,2.721-4.22,6.338-4.22,10.186 c0,3.848,1.498,7.465,4.22,10.187c2.721,2.721,6.338,4.219,10.186,4.219s7.465-1.499,10.186-4.219 c2.722-2.721,4.22-6.338,4.22-10.187c0-3.848-1.498-7.465-4.22-10.186C140.799,64.13,137.182,62.631,133.335,62.631z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.371 210.371",
    style: {
      enableBackground: "new 0 0 210.371 210.371"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest);
export default __webpack_public_path__ + "static/media/best.22621cb4.svg";
export { ForwardRef as ReactComponent };